import { useLocation, useNavigate } from "react-router-dom";
import FooterButton from "../footer/footerButton";
import "./wrong.css";

function Wrong({ onClose }) {
  const location = useLocation();
  const navigate = useNavigate();

  const { nextState, message } = location.state || {};

  const isNextStage = !!nextState;

  const handleClick = () => {
    if (isNextStage) {
      navigate(nextState.route, { state: nextState });
    } else {
      onClose?.();
    }
  };

  return (
    <div id="content" className="wrongDiv">
      <div class="boxPop content_box1">
        <div className="box_con ">
          <div className="missionDiv missionDivPopHeight">
            <div className="missionDi">
              <div
                className="mission_txt_b"
                dangerouslySetInnerHTML={{
                  __html: message || "틀린 것 같아... <br/> 다시 찾아보자!",
                }}
              />
              <FooterButton
                ftIdName="box_ft"
                buttonClass="inputBtn02 con_box_wrong_btn"
                buttonValue={isNextStage ? nextState.btnTxt : "돌아가기"}
                onFinish={handleClick}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Wrong;
